import {
  Settings,
  Smartphone,
  Brush,
  Lightbulb,
  Cloud,
  Layers,
  ArrowRight,
} from "lucide-react";
import { cardData } from "../../../types/Types";

const servicesData: cardData[] = [
  {
    icon: Settings,
    title: "Web Development",
    description: "Hastening your business time to market.",
    id: "",
  },
  {
    icon: Smartphone,
    title: "Mobile App Development",
    description: "Scaling your business and expanding your customer base.",
    id: "",
  },
  {
    icon: Brush,
    title: "UI and UX",
    description:
      "Creating an amazing favorable impression of your brand in the customer's mind.",
    id: "",
  },
  {
    icon: Lightbulb,
    title: "Creative Support",
    description:
      "Elevating your business growth with our customized and resourceful creatives.",
    id: "",
  },
  {
    icon: Cloud,
    title: "Cloud",
    description:
      "Making your business more scalable, agile, and adaptable, with enhanced security, yet cost-effective.",
    id: "",
  },
  {
    icon: Layers,
    title: "IT Consulting",
    description:
      "Strategic guidance and expert advice for your technology needs, ensuring optimal performance and growth.",
    id: "",
  },
];

export default servicesData;
